import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';
import 'es6-promise/auto';
//import "isomorphic-fetch";
import router from "./router";


Object.keys(rules).forEach(rule => {
  extend(rule, {...rules[rule], message: messages[rule]});
});


import 'bootstrap-vue/dist/bootstrap-vue.css';
import Bootstrap from '../vendor/bootstrap/bootstrap.less';
import store from '@/store/index';

Vue.use(Bootstrap);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
